

import __layout_0 from '/src/layouts/default.vue'
export const layouts = {
'default': __layout_0,
'main': () => import('/src/layouts/main.vue'),
'public': () => import('/src/layouts/public.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
